import { transportCategories } from "../../components/search/categories";
import { bodyMatches } from "../search/catalog";
import { haversine } from "../search/liveTrucks";
import { bodyTypeName } from "./common";

const terms = (s) => (s || "").split(",").map((t) => t.trim().toLowerCase()).filter(Boolean);
const cityKey = (s) => String(s ?? "").split(",")[0].trim().toLowerCase();
const addrMatch = (order, dir, text) => {
  const t = terms(text);
  if (!t.length) return true;
  const hay = `${order[`${dir}_address`] || ""} ${order[`${dir}_country`] || ""}`.toLowerCase();
  return t.some((x) => hay.includes(x));
};

const categoryName = (id) => transportCategories.find((c) => c.value === Number(id))?.label || null;

const pad = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const dayFrom = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return ymd(d);
};

/**
 * Client-side filter of published loads with the same search window as the transport search
 * (EMPTY_FILTERS): route + radius, body type, category, weight, volume, loading day, rate «от».
 * Every filter is optional — an empty form returns everything.
 */
export function filterLoads(orders, f) {
  const o = cityKey(f.origin);
  const radius = f.radius === "all" || !f.radius ? null : Number(f.radius);
  let center = null;
  if (o && radius) {
    const pts = orders.filter((x) => cityKey(x.from_address) === o && x.location_from?.lat != null);
    if (pts.length) {
      center = {
        lat: pts.reduce((s, x) => s + Number(x.location_from.lat), 0) / pts.length,
        lng: pts.reduce((s, x) => s + Number(x.location_from.lng), 0) / pts.length,
      };
    }
  }
  const minW = Number(f.capacity) || 0;
  const minV = Number(f.volume) || 0;
  const minPrice = Number(f.price) || 0;
  const day = f.available === "today" ? dayFrom(0) : f.available === "tomorrow" ? dayFrom(1) : null;
  return orders.filter((x) => {
    if (o && radius && center && x.location_from?.lat != null) {
      const near = haversine(center, { lat: Number(x.location_from.lat), lng: Number(x.location_from.lng) }) <= radius;
      if (!near && !addrMatch(x, "from", f.origin)) return false;
    } else if (!addrMatch(x, "from", f.origin)) return false;
    if (!addrMatch(x, "to", f.destination)) return false;
    if (!bodyMatches(f.body, bodyTypeName(x.transport_body_type))) return false;
    if (f.category && f.category !== "Любая" && categoryName(x.transport_category) !== f.category) return false;
    if (f.cargo && f.cargo !== "all" && String(x.item?.type) !== String(f.cargo)) return false;
    if (minW && !(x.item?.weight != null && Number(x.item.weight) >= minW)) return false;
    if (minV && !(x.item?.volume != null && Number(x.item.volume) >= minV)) return false;
    if (minPrice && !(x.price != null && Number(x.price) >= minPrice)) return false;
    if (day) {
      const a = x.from_date || x.to_date;
      const b = x.to_date || x.from_date;
      if (a && (day < a || day > b)) return false;
    }
    // loading window [from_date, to_date] overlaps the chosen range
    if (f.dateFrom || f.dateTo) {
      const a = x.from_date || x.to_date;
      const b = x.to_date || x.from_date;
      if (a && f.dateTo && a > f.dateTo) return false;
      if (b && f.dateFrom && b < f.dateFrom) return false;
    }
    return true;
  });
}
